<template>
  <v-app class="manage-user-group">
    <Header />
    <div class="container pa-0">
      <div v-if="isLoading">
        Loading...
      </div>
      <div v-if="this.$route.name === 'EditUserGroup'">
        <router-view></router-view>
      </div>
      <div v-else-if="this.$route.name === 'NewUserGroup'">
        <router-view></router-view>
      </div>
      <div v-else class="user-wrapper">
        <div class="d-flex justify-space-between pt-5 pb-5 align-items-center">
          <span class="font-weight-bold black--text title">User Groups</span>
          <span class="font-weight-medium black--text"
            >{{ totalResults }} Results</span
          >
        </div>
        <div class="d-flex justify-space-between mb-5">
          <v-row :align="align" no-gutters>
            <v-col cols="6">
              <v-text-field
                v-model="search"
                label="Search group here"
                prepend-inner-icon="mdi-magnify"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="d-flex justify-end align-end">
              <v-btn
                tile
                outlined
                @click="goToDeleteUserGroup"
                ripple="false"
                border="solid"
                height="40"
                elavation="0"
                min-width="100px"
                class="mr-5 text-capitalize black--text font-weight-bold"
                :disabled="selected.length === 0 ? true : false"
                >Delete</v-btn
              >
              <v-btn
                class="btn-solid text-capitalize"
                tile
                @click="newUser"
                color="#3a83c3"
                dark
                height="40"
                min-width="100px"
                ripple="false"
                elavation="0"
              >
                <span tile
                  ><v-icon right class="mr-2"> mdi-plus </v-icon>New User Group
                </span></v-btn
              >
            </v-col>
          </v-row>
        </div>
        <v-data-table
          class="user-group-table"
          :headers="headers"
          :items="usergroups"
          v-model="selected"
          :single-select="singleSelect"
          item-key="name"
          show-select
          :search="search"
          elevation="0"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 75]
          }"
          :loading="loading"
          :items-per-page="10"
          @click:row="editRow"
          fixed-header
          height="510"
        >
          <template v-slot:[`item.name`]="{ item }">
            <div class="group-name-truncate" :title="item.name">
              {{ item.name }}
            </div>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <div v-if="loading">Loading...Please wait</div>
            <div v-else>
              {{ moment(item.created_at).format("DD MMM YYYY") }}
            </div>
          </template>
          <template v-slot:[`item.created_by`]="{ item }">
            <div class="group-by-truncate" :title="item.created_by">
              {{ item.created_by }}
            </div>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            {{item.status}}
          </template>
          <template v-slot:[`item.shortcut`]="{ item }">
            <div class="toggle-switch">
            <v-switch
              class="mt-2"
              v-model="item.shortcut"
              :label="item.shortcut ? 'Yes' : 'No'"
              :ripple="false"
              @change="change"
              :class="[
                item.status === 'INACTIVE'
                  ? 'btn-disabled'
                  : ''
              ]"
            ></v-switch>
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu open-on-click bottom left offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon medium class="mr-2" v-bind="attrs" v-on="on">
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list class="user-group-action">
                <v-list-item
                  @click="editItem(item, index)"
                  class="text-uppercase"
                  >edit</v-list-item
                >
                <v-list-item
                  @click="deleteItem(item, index)"
                  class="text-uppercase"
                  >delete</v-list-item
                >
                <v-list-item
                  @click="changeStatus(item, index)"
                  class="text-uppercase"
                  v-if="item.status === 'ACTIVE'"
                  v-bind="!item.status"
                  >{{ inactive }}</v-list-item
                >
                <v-list-item
                  @click="changeStatus(item, index)"
                  class="text-uppercase"
                  v-else
                  v-bind="item.status"
                  >{{ active }}</v-list-item
                >
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </div>
    </div>
  </v-app>
</template>

<script>
import Crypto from "../../encrypt";
import moment from "moment";
import { bus } from "../../main";
import Header from "../Header/HeaderPage";
export default {
  name: "UserGroup",
  props: {
    msg: String
  },
  components: {
    Header
  },
  data: () => ({
    results: 10,
    search: "",
    selected: [],
    itemsSelected: [],
    sorting: true,
    isLoading: false,
    dialog: false,
    loading: true,
    singleSelect: false,
    dialogDelete: false,
    inactive: "INACTIVE",
    active: "ACTIVE",
    headers: [
      {
        text: "Group Name",
        align: "start",
        sortable: true,
        filterable: true,
        value: "name",
        width: "35%"
      },
      {
        text: "Created On",
        value: "created_at",
        width: "20%",
        filterable: false
      },
      {
        text: "Created By",
        value: "created_by",
        width: "25%",
        filterable: false
      },
      { text: "Status", value: "status", width: "10%", filterable: false },
      { text: "Shortcut", value: "shortcut", width: "10%", filterable: false },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "10%",
        filterable: false
      }
    ],
    totalResults: "",
    usergroups: [
      {
        name: "",
        created_at: "",
        created_by: "",
        status: ""
      }
    ],
    editedIndex: -1,
    createdByDate: "",
    statustochange: "",
    itemsPerPage: 2,
    editedItem: {
      id: "",
      name: "",
      created_at: "",
      created_by: "",
      status: ""
    },
    groupstatus: [],
    finalgroupstatus: "",
    defaultItem: {
      name: "",
      Created_on: "",
      Created_by: "",
      Status: ""
    },
    edits: [
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me" },
      { title: "Click Me 2" }
    ],
    editqueryparam: {
      usergroup: ""
    },
    deleteditem_idparam: {
      usergroup: []
    },
    deleteAll_idparam: {
      usergroup: []
    },
    statusqueryparam: {
      id: "",
      status: ""
    }
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  },
  created() {
    //this.groupsTableDataCall(null, 1);
  },
  watch: {
    $route: "groupsTableDataCall",
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    selected() {
      this.selected.forEach(ele => {
        this.itemsSelected.push(id);
      });
    }
  },

  mounted() {
    this.groupsTableDataCall(null, 1);
    this.$forceUpdate();
  },

  methods: {
    newUser() {
      this.$router.push({ name: "NewUserGroup" });
    },
    //for edit each group action
    editItem(item, index) {
      this.$router.push({ name: "EditUserGroup" });
      this.editqueryparam.usergroup = item.id;
      const domainUrl = "api/usergroupedit/";
      let vm = this;
      vm.$apiService
        .getData("get", `${domainUrl}`, {}, {}, null, this.editqueryparam)
        .then(data => {
          // window.localStorage.setItem('data', item.id)
          bus.$emit("clicked-on-edit", data.data);
          console.log('test',data)
        });
    },
    /*----To edit row on click---*/
    editRow(item, row) {
      const id = item.id;
      this.$router.push({ name: "EditUserGroup" });
      this.editqueryparam.usergroup = id;
      const domainUrl = "api/usergroupedit/";
      let vm = this;
      vm.$apiService
        .getData("get", `${domainUrl}`, {}, {}, null, this.editqueryparam)
        .then(data => {
          bus.$emit("clicked-on-edit", data.data);
        });
      let selectState = row.selected ? true : false;
      row.select(selectState);
    },

    //change status of group
    changeStatus(item, index) {
      let statusitem = item;
      if(item.status === 'ACTIVE'){
        statusitem.status = false
      }else{
        statusitem.status = true
        statusitem.shortcut = false
        statusitem.shortcut = "No"
      }
      const domainUrl = `api/usergroup/`;
      let vm = this;
      vm.$apiService
        .getData("put", `${domainUrl}`, {}, statusitem, null, null)
        .then(data => {
            if(item.status === true){
              item.status = 'ACTIVE'
            }else{
              item.status = 'INACTIVE'
              item.shortcut = "No"
              item.shortcut = false
            }
        });
    },

    //get usergroup data api call
    groupsTableDataCall(params, item) {
      const routerPath = "/user-group";
      const domainUrl = "api/usergroup/";
      let vm = this;
      if (vm.$apiService) {
        this.isLoading = true;
        if (routerPath === this.$route.path) {
          vm.$apiService
            .getData("get", `${domainUrl}`, {}, {}, null, this.editedItem)
            .then(data => {
              console.log('2',data)
              if (data) {
                this.totalResults = data.data.length;
                this.usergroups = data.data;
                this.usergroups.forEach (ele => {
                  if(ele.status === true){
                    ele.status = 'ACTIVE'
                  }else{
                    ele.status = 'INACTIVE'
                  }
                })
                this.loading = false;
              }
            });
        }
      }
    },

    //for single and multiple delete user groups
    deleteItem(item, index) {
      this.$swal({
        icon: "warning",
        title: "Are you sure you want to delete the selected Group?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(res => {
        if (res.isConfirmed === true) {
          this.deleteditem_idparam.usergroup = Crypto.get(item.uid);
          //?usergroup=1     --> for single delete
          const domainUrl = "api/usergroupedit/";
          let vm = this;
          vm.$apiService
            .getData(
              "delete",
              `${domainUrl}`,
              {},
              {},
              null,
              this.deleteditem_idparam
            )
            .then(data => {
              this.groupsTableDataCall(null, 1);
              vm.$forceUpdate();
              /* this is for delete all button enabling based on select and delete operations performed */
              let ind = this.selected.findIndex( ele => {
                return ele.uid === item.uid
              })
              if(index !== -1){
                this.selected.splice(ind, 1)
              }
            });
        }
      });
    },
    //delete group api call
    deletegroupCall() {
      const domainUrl = "api/usergroupedit/";
      let vm = this;
      vm.$apiService
        .getData("delete", `${domainUrl}`, {}, {}, null, this.deleteAll_idparam)
        .then(data => {
          vm.$forceUpdate();
          /*on each delete operation we are emptying the delete params so that deleted values wont get pushed on to the array*/
          this.deleteAll_idparam.usergroup = [];
          vm.groupsTableDataCall(null, null);
        });

      this.selected.forEach(ele => {
        this.deleteAll_idparam.usergroup.push(Crypto.get(ele.uid));
      });
    },
    /*--to delete one or more rows--*/
    goToDeleteUserGroup() {
      let selectedCount = this.selected.length
      this.$swal({
        icon: "warning",
        title: `Are you sure you want to delete the selected ${selectedCount} Group(s)?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(res => {
        if (res.isConfirmed === true) {
          let vm = this;
          vm.deletegroupCall();
          this.selected = [];
        }
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    }
  }
};
</script>
<style lang="scss">
@import "../UserGroup/ManageUserGroup.scss";
.manage-user-group .theme--light.v-data-table tbody tr.v-data-table__selected {
  background: #eee !important;
}
.manage-user-group .theme--dark.v-data-table tbody tr.v-data-table__selected {
  background: #eee !important;
  cursor: pointer;
}
.manage-user-group .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
  cursor: pointer;
}
</style>
